import React, {useState} from "react";
import OperadoresTabela from "./OperadoresTabela";
import OperadorDialog from "./OperadorDialog";

const OperadoresMainView = (props) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [registro, setRegistro] = useState(null);

    const cbOpenDialog = (b, rD) => {
        setRegistro(rD);
        setDialogOpen(b);
    }

    return (
        <React.Fragment>
            {dialogOpen && <OperadorDialog isOpen={dialogOpen} cbDialog={cbOpenDialog} registro={registro} />}
            <OperadoresTabela openDialog={cbOpenDialog} />
        </React.Fragment>
    )
}

export default OperadoresMainView;
